import Counter from '../../components/counter';
//HomePage
function HomePage() {
	return (
		<div className="row">
			<h1>Home Page </h1>
			<hr />
			<Counter />
		</div>
	);
}

export default HomePage;
